import script from "./TabPaneComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabPaneComponent.vue?vue&type=script&setup=true&lang=ts"

import "./TabPaneComponent.vue?vue&type=style&index=0&id=12bac87a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12bac87a"]])

export default __exports__